import { useFormikContext } from 'formik';

export const useStipReport = () => {
  const formikContext = useFormikContext();

  const { setFieldValue, values } = formikContext;

  const handleToggleChange = event => {
    if (!event) return;
    const field = event.target.name;
    setFieldValue(field, !values[field]);
  };

  const handleRadioChange = event => {
    if (!event) return;
    const field = event.target.name;
    const value = Number.isNaN(+event.target.value) ? event.target.value : parseInt(event.target.value) ;
    setFieldValue(field, value);
  };

  const handleSelectChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    setFieldValue(field, value);
  };

  return {
    handleToggleChange,
    handleRadioChange,
    handleSelectChange,
  };
};